import { render, staticRenderFns } from "./AdvertsMap.vue?vue&type=template&id=57b50f13&lang=pug&"
import script from "./AdvertsMap.vue?vue&type=script&lang=js&"
export * from "./AdvertsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports